import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-fec7644c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "head"
}
const _hoisted_2 = {
  key: 0,
  class: "photo"
}
const _hoisted_3 = {
  key: 1,
  class: "head"
}
const _hoisted_4 = {
  key: 0,
  class: "photo"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_6 = { class: "space" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Usuario", -1))
const _hoisted_8 = { class: "inputProfile" }
const _hoisted_9 = { class: "inputProfile" }
const _hoisted_10 = { class: "space" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Email", -1))
const _hoisted_12 = { class: "inputProfile" }
const _hoisted_13 = { class: "inputProfile" }
const _hoisted_14 = { class: "inputProfile" }
const _hoisted_15 = { class: "space" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Contraseña", -1))
const _hoisted_17 = { class: "inputProfile" }
const _hoisted_18 = { class: "inputProfile" }
const _hoisted_19 = { class: "inputProfile" }
const _hoisted_20 = { class: "space" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Empleo", -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import ProfileService from '@/services/ProfileService'
import { onMounted, ref, Ref } from 'vue';
import { useAuth } from '@/store/useAuth';
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import router from '@/router';
import useWindowWidth from '@/composables/useWindowWidth';
import ProfileImage from '@/components/widgets/ProfileImage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

const profileService = new ProfileService()
const profile:Ref<any> = ref('')
const percentage = ref(0)
const store = useAuth()
const toast = useToast()
const {windowWidth} = useWindowWidth()
const tableSmall= ref(850);

const old_password = ref('')
const new_password = ref('')
const repeat_password = ref('')

const current_email = ref('')
const new_email = ref('')
const repeat_email = ref('')

onMounted(async () => {
    if(!store.token) {
        return null;
    }

    profile.value = await profileService.GetProfileInfo(store.token)
    percentage.value = await profileService.GetJobProfilePercentageAcomplishedInfo(store.token)
})


const OnUpdateName = async () => {
    if(!store.token) {
        return null;
    }
    await profileService.UpdateName(store.token, profile.value.name, profile.value.telephone);
    toast.showToast("Perfil actualizado.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
}

const OnUpdateEmail = async () => {
    if(!store.token) {
        return null;
    }

    if(new_email.value != repeat_email.value) {
        toast.showToast("Los emails no coincididen.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
    }

    if((new_email.value == "")||(new_email.value == null)||(new_email.value == undefined)||(new_email.value == " "))
    {
        toast.showToast("Campos vacíos.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }

    const response = await profileService.UpdateEmail(store.token, current_email.value, new_email.value, repeat_email.value)

    if(response == "error") {
        toast.showToast("Error al actualizar email.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }

    store.email = new_email.value
    current_email.value = ""
    new_email.value = ""
    repeat_email.value = ""

    toast.showToast("Perfil actualizado.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
    
}

const OnUpdatePassword = async () => {
    if(!store.token) {
        return null;
    }
    if(new_password.value != repeat_password.value) {
        toast.showToast("Las contraseñas no coinciden.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }
    if((new_password.value == "")||(new_password.value == null)||(new_password.value == undefined)||(new_password.value == " "))
    {
        toast.showToast("Campos vacíos.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }
    const response = await profileService.UpdatePassword(store.token, old_password.value, new_password.value, repeat_password.value)

    if(response == "error") {
        toast.showToast("Error al actualizar la contraseña.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }
    toast.showToast("Perfil actualizado.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
}

const GoToJobProfile = () => {
    router.push({name: 'job-profile'})
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (!profile.value.profile_picture_uri)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            ( _unref(windowWidth)>tableSmall.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(ProfileImage)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("h1", null, _toDisplayString(profile.value.name), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            ( _unref(windowWidth)>tableSmall.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(ProfileImage)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("h1", null, _toDisplayString(profile.value.name), 1)
          ])),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("form", _hoisted_8, [
          _createVNode(_component_v_icon, { name: "fa-user-alt" }),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Nombre completo",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((profile.value.name) = $event))
          }, null, 512), [
            [_vModelText, profile.value.name]
          ])
        ]),
        _createElementVNode("form", _hoisted_9, [
          _createVNode(_component_v_icon, { name: "bi-telephone-fill" }),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Número de telefono",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profile.value.telephone) = $event))
          }, null, 512), [
            [_vModelText, profile.value.telephone]
          ])
        ]),
        _createElementVNode("button", {
          class: "primary-button",
          onClick: OnUpdateName
        }, "Actualizar")
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("form", _hoisted_12, [
          _createVNode(_component_v_icon, { name: "md-email" }),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            placeholder: "Email actual",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((current_email).value = $event))
          }, null, 512), [
            [_vModelText, current_email.value]
          ])
        ]),
        _createElementVNode("form", _hoisted_13, [
          _createVNode(_component_v_icon, {
            name: "md-fibernew-round",
            style: {"scale":"1.1"}
          }),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            placeholder: "Nuevo email",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((new_email).value = $event))
          }, null, 512), [
            [_vModelText, new_email.value]
          ])
        ]),
        _createElementVNode("form", _hoisted_14, [
          _createVNode(_component_v_icon, { name: "md-replay" }),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            placeholder: "Repita nuevo email",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((repeat_email).value = $event))
          }, null, 512), [
            [_vModelText, repeat_email.value]
          ])
        ]),
        _createElementVNode("button", {
          class: "primary-button",
          onClick: OnUpdateEmail
        }, "Actualizar")
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("form", _hoisted_17, [
          _createVNode(_component_v_icon, { name: "ri-lock-password-fill" }),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            placeholder: "Contraseña actual",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((old_password).value = $event))
          }, null, 512), [
            [_vModelText, old_password.value]
          ])
        ]),
        _createElementVNode("form", _hoisted_18, [
          _createVNode(_component_v_icon, {
            name: "md-fibernew-round",
            style: {"scale":"1.1"}
          }),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            placeholder: "Nueva contraseña",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((new_password).value = $event))
          }, null, 512), [
            [_vModelText, new_password.value]
          ])
        ]),
        _createElementVNode("form", _hoisted_19, [
          _createVNode(_component_v_icon, { name: "md-replay" }),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            placeholder: "Repita nueva contraseña",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((repeat_password).value = $event))
          }, null, 512), [
            [_vModelText, repeat_password.value]
          ])
        ]),
        _createElementVNode("button", {
          class: "primary-button",
          onClick: OnUpdatePassword
        }, "Actualizar")
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("label", null, "Perfil completado al " + _toDisplayString(percentage.value) + "%", 1),
        _createElementVNode("button", {
          class: "primary-button",
          onClick: GoToJobProfile
        }, "Ir a mi perfil de empleo")
      ])
    ]),
    _: 1
  }))
}
}

})